<template>
    <!-- <Popup /> -->
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <Header :agency="agency" :bg_img="bg_img"></Header>
    <Layout>
        <!-- Hometemplate.php -->
        <div class="to-buy-page-template">
            <section class="page-header-section full-view-header content-in-center no-margin">
                <div class="image-block"
                     style="background-image: url('https://www.ewigo.com/wp-content/uploads/2025/02/trouvez_votre_voiture-min.png')">
                </div>
                <div class="container">
                    <h1 class="h1 white anim fade right">Trouvez le vehicule de<br>vos rêves</h1>
                    <h4 class="h4 white anim fade right delay1">pour parcourir les routes en toute sérénité</h4>
                    <div class="form-section">
                        <div class="form-block anim fade right delay2">
                            <div class="input-box">
                                <input type="text" placeholder="Recherche de mon véhicule" v-model="kw">
                            </div>
                            <a class="submit-button" href="#points-of-sale-grid-section">
                                <input type="submit">
                            </a>
                        </div>
                    </div>
                    <div class="search-section anim fade up delay3">
                        <div class="search-list">
                            <div class="list">
                                <div class="box-header" :class="{active: activeFilter == 'type'}"
                                     @click="toggleFilter('type')">Type
                                </div>
                                <div class="box-detail" :class="{boxblock: activeFilter == 'type'}">
                                    <div class="checklist">
                                        <div class="check-box-custom" v-for="item in choices.categories"
                                             :key="item.category">
                                            <input type="checkbox" :value="item.category" v-model="filter.type">
                                            <div class="data">
                                                {{ item.category }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list">
                                <div class="box-header" :class="{active: activeFilter == 'brand'}"
                                     @click="toggleFilter('brand')">Marque
                                </div>
                                <div class="box-detail" :class="{boxblock: activeFilter == 'brand'}">
                                    <div class="checklist">
                                        <div class="check-box-custom" v-for="item in choices.makes" :key="item.make">
                                            <input type="checkbox" :value="item.make" v-model="filter.marque">
                                            <div class="data">
                                                {{ item.make }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list">
                                <div class="box-header" :class="{active: activeFilter == 'model'}"
                                     @click="toggleFilter('model')">Modèle
                                </div>
                                <div class="box-detail" :class="{boxblock: activeFilter == 'model'}">
                                    <div class="checklist">
                                        <div class="check-box-custom" v-for="item in choices.models" :key="item.model">
                                            <input type="checkbox" :value="item.model" v-model="filter.modele">
                                            <div class="data">
                                                {{ item.model }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list">
                                <div class="box-header" :class="{active: activeFilter == 'energy'}"
                                     @click="toggleFilter('energy')">Carburant
                                </div>
                                <div class="box-detail" :class="{boxblock: activeFilter == 'energy'}">
                                    <div class="checklist">
                                        <div class="check-box-custom" v-for="item in choices.energies"
                                             :key="item.energy">
                                            <input type="checkbox" :value="item.energy" v-model="filter.energie">
                                            <div class="data">
                                                {{ item.energy }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list">
                                <div class="box-header" :class="{active: activeFilter == 'gear'}"
                                     @click="toggleFilter('gear')">Boite de vitesse
                                </div>
                                <div class="box-detail" :class="{boxblock: activeFilter == 'gear'}">
                                    <div class="checklist">
                                        <div class="check-box-custom" v-for="item in choices.vitesses" :key="item">
                                            <input type="checkbox" :value="item" v-model="filter.vitesse">
                                            <div class="data">
                                                {{ item }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="list">
                                <div class="box-header" :class="{active: activeFilter == 'year'}"
                                     @click="toggleFilter('year')">Année
                                </div>
                                <div class="box-detail" :class="{boxblock: activeFilter == 'year'}">
                                    <div class="box">
                                        <span class="label-input">Min : </span>
                                        <input class="filter-input" type="number"
                                            placeholder="Rentrer année min" v-model="filter.year_min"
                                            :min="0"
                                            :max="100000"/>
                                    </div>
                                    <div class="box">
                                        <span class="label-input">Max : </span>
                                        <input class="filter-input" type="number"
                                            placeholder="Rentrer année max" v-model="filter.year_max"
                                            :min="0"
                                            :max="100000"/>
                                    </div>
                                </div>
                            </div>
                            <div class="list">
                                <div class="box-header" :class="{active: activeFilter == 'km'}"
                                     @click="toggleFilter('km')">Kms
                                </div>
                                <div class="box-detail" :class="{boxblock: activeFilter == 'km'}">
                                    <div class="box">
                                        <span class="label-input">Min : </span>
                                        <input class="filter-input" type="number"
                                            placeholder="Rentrer kms min" v-model="filter.kms_min"
                                            :min="0"
                                            :max="120000"/>
                                    </div>
                                    <div class="box">
                                        <span class="label-input">Max : </span>
                                        <input class="filter-input" type="number"
                                            placeholder="Rentrer kms max" v-model="filter.kms_max"
                                            :min="0"
                                            :max="120000"/>
                                    </div>
                                </div>
                            </div>
                            <div class="list">
                                <div class="box-header" :class="{active: activeFilter == 'price'}"
                                     @click="toggleFilter('price')">Prix
                                </div>
                                <div class="box-detail" :class="{boxblock: activeFilter == 'price'}">
                                    <div class="box">
                                        <span class="label-input">Min : </span>
                                        <input class="filter-input" type="number"
                                            placeholder="Rentrer prix min" v-model="filter.price_min"
                                            :min="0"
                                            :max="100000"/>
                                    </div>
                                    <div class="box">
                                        <span class="label-input">Max : </span>
                                        <input class="filter-input" type="number"
                                            placeholder="Rentrer prix max" v-model="filter.price_max"
                                            :min="0"
                                            :max="100000"/>
                                    </div>
                                </div>
                            </div>
                            <div class="list">
                                <div class="box-header filter-reliable">
                                     <div class="check-box-custom">
                                        <input type="checkbox" :value="true" v-model="filter.reliable">
                                        <div class="data">
                                            Fiable ou remboursé
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="more-option-screen">
                    <div class="cross-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="27.42" height="30.278"
                             viewBox="0 0 27.42 30.278">
                            <g id="fermer" transform="translate(2.118 2.118)">
                                <line id="Line_52" data-name="Line 52" x2="23.184" y2="26.042" fill="none"
                                      stroke="#1c1b1b" stroke-linecap="round" stroke-width="3"/>
                                <line id="Line_53" data-name="Line 53" x1="23.184" y2="26.042" fill="none"
                                      stroke="#1c1b1b" stroke-linecap="round" stroke-width="3"/>
                            </g>
                        </svg>
                    </div>
                    <h2>Plus d’options</h2>
                    <div class="form-group">
                        <label for="">Nombre de places</label>
                        <div class="checklist">
                            <div class="check-box-custom">
                                <input type="checkbox">
                                <div class="data">
                                    4
                                </div>
                            </div>
                            <div class="check-box-custom">
                                <input type="checkbox">
                                <div class="data">
                                    4
                                </div>
                            </div>
                            <div class="check-box-custom">
                                <input type="checkbox">
                                <div class="data">
                                    4
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">Nombre de places</label>
                        <div class="checklist">
                            <div class="check-box-custom">
                                <input type="checkbox">
                                <div class="data">
                                    4
                                </div>
                            </div>
                            <div class="check-box-custom">
                                <input type="checkbox">
                                <div class="data">
                                    4
                                </div>
                            </div>
                            <div class="check-box-custom">
                                <input type="checkbox">
                                <div class="data">
                                    4
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-block range-calculator">
                        <div class="form-group range-input">
                            <label for="">
                                Emissions CO2 (g/Km)
                            </label>
                            <div class="input-block">
                                <input type="range" name="" id="range1" min="0" max="100">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">Chevaux (ch)</label>
                        <div class="input-list">
                            <input type="text">
                            <input type="text">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">Chevaux (ch)</label>
                        <div class="input-list">
                            <input type="text">
                            <input type="text">
                        </div>
                    </div>
                    <div class="form-block range-calculator">
                        <div class="form-group range-input">
                            <label for="">
                                <span>Emissions CO2 (g/Km)</span>
                                <span class="main">2010</span>
                            </label>
                            <div class="input-block">
                                <input type="range" name="" id="range2" min="0" max="100">
                            </div>
                        </div>
                    </div>
                </div>
                <a href="#points-of-sale-grid-section" class="down-btn scroll-to" aria-label="Soumettre les filtres"></a>
            </section>

            <section class="points-of-sale-grid-section" id="points-of-sale-grid-section">
                <div class="container">
                    <div class="search-header">
                        <div>
                            <p><b>{{ ads.total + adsNetwork.total }}</b> Résultats</p>
                        </div>
                        <div class="sort-by">
                            <select name="" id="" v-model="sort">
                                <option value="" selected>Trier par</option>
                                <option v-for="item in sortBy" :value="item.value" :key="item.value">{{ item.label }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="posts-list-grid">
                        <div class="row">
                            <template v-for="(item, index) in ads.data" :key="item.id+JSON.stringify(favoris)">

                                <ad :ad="item" :network="false" :favoris="favoris" v-if="favoris"></ad>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 1">
                                    <a :href="route('minisite.services')+'#livraison'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2021/10/Groupe-362@2x.png');"></div>
                                        </div>
                                    </a>
                                </div>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 4">
                                    <a :href="route('minisite.services')+'#financement'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2021/10/Groupe-363@2x.png');"></div>
                                        </div>
                                    </a>
                                </div>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 7">
                                    <a :href="route('minisite.services')+'#garantie'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/05/Garantie-1.png');"></div>
                                        </div>
                                    </a>
                                </div>

                                <div class="col-lg-4 col-md-6 post-pub" v-if="index == 10">
                                    <a :href="route('minisite.services')+'#pack'">
                                        <div class="post-block to-buy-list featured">
                                            <div class="thumbnail thumbnail-contain"
                                                 style="background-image: url('https://www.ewigo.com/wp-content/uploads/2022/05/pack.png');"></div>
                                        </div>
                                    </a>
                                </div>


                            </template>

                        </div>
                    </div>
                    <div class="separator-list-grid">
                        <hr>
                        <div class="row">
                            <p>Ces véhicules présents dans d’autres points de vente pourraient vous intéresser.
                                Bénéficiez de la livraison dans toute le France !</p>
                        </div>
                    </div>
                    <div class="posts-list-grid">
                        <div class="row">
                            <ad v-for="item in adsNetwork.data" :key="item.id+JSON.stringify(favoris)" :ad="item" :network="true"
                                :favoris="favoris" v-if="favoris"></ad>
                        </div>
                    </div>
                    <div class="posts-list-grid">
                        <div class="row justify-content-center">
                            <pagination class="mt-6" :links="adsNetwork.links"/>
                        </div>
                    </div>
                </div>
            </section>
        </div>


    </Layout>
    <Footer :agency="agency" :bg_img="bg_img"></Footer>
</template>

<script>
import _, {throttle} from 'lodash';
import Layout from './Layout'
import {Head} from '@inertiajs/inertia-vue3'
import Footer from "@/Pages/Partials/Footer"
import Header from "@/Pages/Partials/Header"
import Ad from "@/Pages/Partials/Ad"
import Pagination from '@/Components/Pagination'
import Slider from '@vueform/slider'
import {formatMileage} from "@/helpers/format-mileage";
import {formatPrice} from "@/helpers/format-price";
// import Popup from "@/Pages/Partials/Popup"

export default {
    components: {
        Head,
        Layout,
        Footer,
        Header,
        Ad,
        Pagination,
        Slider,
        // Popup,
    },
    props: {
        agency: Object,
        makes: Object,
        models: Object,
        categories: Object,
        energies: Object,
        ads: Object,
        bg_img: String,
        adsNetwork: Object,
        body_class: String,
        title: String,
        description: String,
    },
    data() {
        return {
            activeFilter: null,
            filter: {
                type: [],
                marque: [],
                modele: [],
                energie: [],
                vitesse: [],
                kms_min: null,
                kms_max: null,
                year_mix: null,
                year_max: null,
                price_min: null,
                price_max: null,
                reliable: false,
            },
            choices: {
                makes: this.makes,
                models: this.models,
                energies: this.energies,
                categories: this.categories,
                vitesses: ['Automatique', 'Manuelle'],
            },
            sort: '-id',
            kw: '',
            loaded: false,
            sortBy: [
                {value: '-id', label: 'Date du + au - récent'},
                {value: 'id', label: 'Date du - au + récent'},
                {value: '-price', label: 'Prix du + au - cher'},
                {value: 'price', label: 'Prix du - au + cher'},
            ],
            favoris: [],
        }
    },
    watch: {
        filter: {
            deep: true,
            handler: _.debounce(function () {
                this.$inertia.get(route('minisite.acheter') + '?' + this.queryString, {}, {
                    preserveState: true,
                    preserveScroll: true
                })
            }, 300)
        },
        kw: {
            deep: true,
            handler: _.debounce(function () {
                this.$inertia.get(route('minisite.acheter') + '?' + this.queryString, {}, {
                    preserveState: true,
                    preserveScroll: true
                })
            }, 100)
        },
        sort: {
            deep: true,
            handler: _.debounce(function () {
                this.$inertia.get(route('minisite.acheter') + '?' + this.queryString, {}, {
                    preserveState: true,
                    preserveScroll: true
                })
            }, 100)
        },
        'filter.marque': {
            handler: throttle(function () {
                axios.get(route('minisite.models', {makes: this.filter.marque}))
                    .then((response) => {
                        this.choices.models = response.data
                    })
            }, 500)
        }
    },
    setup() {
        return {
            formatMileage,
            formatPrice,
        }
    },
    created() {
        if (route().params.filter) {
            this.setRouteFilters();
        }

        axios.get(route('api.favoris.get')).then((response) => {
            this.favoris = Object.values(response.data)
        });
    },
    beforeUpdate() {
        //this.loaded = true
    },
    mounted() {
        document.body.classList.add(this.body_class.split(' '))
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const elToGoPosition = document.querySelector(this.getAttribute('href')).getBoundingClientRect().top + window.pageYOffset;
                const headerHeight = document.getElementById('masthead').getBoundingClientRect().height;
                window.scrollTo({
                    top: elToGoPosition - headerHeight,
                    behavior: 'smooth'
                });
            });
        });
    },
    destroyed() {
        document.body.classList.remove(this.body_class.split(' '))
    },
    computed: {
        queryString() {
            let string = '';
            if (this.filter) {
                _.forEach(this.filter, function (value, key) {
                    if (value !== null) {
                        string += `filter[${key}]=${value}&`
                    }
                })
            }
            string += `sort=${this.sort}&`
            //string += `page=${this.ads.current_page}&`
            string += `kw=${this.kw}`

            return string;
        },
    },
    methods: {
        toggleFilter(filter) {
            if (this.activeFilter == filter) {
                this.activeFilter = null;
            } else {
                this.activeFilter = filter;
            }
        },
        setRouteFilters() {
            let filters = route().params.filter
            _.forEach(filters, (filter, name) => {
                if (name == 'price_max' || name == 'kms_max') {
                    this.filter[name] = filter
                } else {
                    this.filter[name] = filter.split(',')
                }
            })
        },
    },

}
</script>
<style scoped lang="scss">

.separator-list-grid {
    margin: 60px 20px;

    p {
        text-align: center;
        width: 100%;
    }
}

.submit-button input:hover {
    background-color: #262626;
    border: 1px solid #262626;
    cursor: pointer;
}


@media screen and (max-width: 768px) {
    .featured {
        height: 400px;
    }
}


.to-buy-page-template .page-header-section .search-section .search-list .list .box-detail {
    &.boxblock {
        display: block;
    }
}


</style>

<style src="@vueform/slider/themes/default.css"></style>
